var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "session-item" }, [
    _c("div", { staticClass: "session-item-info" }, [
      _c("strong", [_vm._v(_vm._s(_vm.session.agent))]),
      _c(
        "a",
        {
          attrs: {
            href: "https://ipinfo.io/" + _vm.session.ip,
            target: "_blank",
            rel: "noopener",
          },
        },
        [_vm._v(_vm._s(_vm.session.ip))]
      ),
      _vm.session.active > 1
        ? _c("p", { staticClass: "session-usage" }, [
            _vm._v(
              "\n\t\t\tActive in " +
                _vm._s(_vm.session.active) +
                " browsers\n\t\t"
            ),
          ])
        : !_vm.session.current && !_vm.session.active
        ? _c("p", { staticClass: "session-usage" }, [
            _vm._v("\n\t\t\tLast used on "),
            _c("time", [_vm._v(_vm._s(_vm.lastUse))]),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "session-item-btn" }, [
      _c(
        "button",
        {
          staticClass: "btn",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.signOut.apply(null, arguments)
            },
          },
        },
        [_vm.session.current ? [_vm._v("Sign out")] : [_vm._v("Revoke")]],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }